import dayjs from 'dayjs'

import { DateService } from 'common/services/dateService'

const { formatInSiteZone } = DateService

export const TEAM_TIME_FORMAT = 'HH:mm'
const DAY_KEY = 'YYYY-MM-DD'

export const formatTeamTime = (iso: string, timeZone: string): string =>
  formatInSiteZone(iso, timeZone, TEAM_TIME_FORMAT)

export const siteDayKey = (iso: string, timeZone: string): string =>
  formatInSiteZone(iso, timeZone, DAY_KEY)

// Day keys are compared as UTC calendar dates, so no zone's DST can shift them.
export const dayLabel = (iso: string, timeZone: string, nowIso: string): string => {
  const day = siteDayKey(iso, timeZone)
  const today = siteDayKey(nowIso, timeZone)
  if (day === today) return 'Today'
  if (day === dayjs.utc(today).subtract(1, 'day').format(DAY_KEY)) return 'Yesterday'
  return formatInSiteZone(iso, timeZone, 'MMM D')
}

// Today shows the time alone; any other site-zone day adds its label.
export const formatTeamStamp = (iso: string, timeZone: string, nowIso: string): string => {
  const time = formatTeamTime(iso, timeZone)
  if (siteDayKey(iso, timeZone) === siteDayKey(nowIso, timeZone)) return time
  return `${dayLabel(iso, timeZone, nowIso)} ${time}`
}
